import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from '@bndes/bndes-ux4/bndes-angular-utils';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataSistemaService } from 'src/app/shared/services/data-sistema.service';
import moment from 'moment';
import { ConsultaCadin } from './consulta-cadin.model';

@Component({
  selector: 'app-consulta-cadin-listar',
  templateUrl: './consulta-cadin-listar.component.html',
  styleUrl: './consulta-cadin-listar.component.scss',
  standalone: false
})
export class ConsultaCadinListarComponent implements OnInit, OnDestroy {

  @Input() public consultas: ConsultaCadin[];
  @Input() public atributosPaginacao: EntityPagedRequestParameters;
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> =
    new EventEmitter<EntityPagedRequestParameters>();

  public opcoesPaginacao: number[] = [10, 15, 20];
  public atributosOrdenacao: EntityOrderedRequestParameters = { atributo: '', sentido: 'asc' };

  // Data do sistema (a mesma exibida na tela inicial), usada para aferir a vigencia da
  // certidao. Nao se usa a data da maquina do usuario, que pode estar diferente.
  private dataSistema: Date;
  private readonly destroy$ = new Subject<void>();

  constructor(private dataSistemaService: DataSistemaService) { }

  ngOnInit() {
    this.dataSistemaService.getDataCorrente()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: Date) => this.dataSistema = data);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.consultas = this.consultas.sort((a, b) => {
      if (ord.sentido === 'asc') {
        return this.compara(a, b, ord.atributo);
      } else {
        return -1 * this.compara(a, b, ord.atributo);
      }
    });
  }

  private compara(a: any, b: any, atributo: string): number {
    const va = this.fetchFromObject(a, atributo);
    const vb = this.fetchFromObject(b, atributo);
    if (va === vb) { return 0; }
    return va > vb ? 1 : -1;
  }

  private fetchFromObject(obj: any, prop: string): any {
    if (typeof obj === 'undefined') {
      return false;
    }
    const _index = prop.indexOf('.');
    if (_index > -1) {
      return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }
    return obj[prop];
  }

  // Formata CNPJ (14 digitos) como XX.XXX.XXX/XXXX-XX; CPF (11) como XXX.XXX.XXX-XX.
  // Se nao bater o tamanho, retorna o valor original.
  formatarCnpjCpf(valor: string): string {
    if (!valor) { return ''; }
    const d = valor.replace(/\D/g, '');
    if (d.length === 14) {
      return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }
    if (d.length === 11) {
      return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    }
    return valor;
  }

  // Vermelho se: e impeditiva (S) OU nao tem data de vigencia OU ja venceu.
  // O vencimento e aferido contra a DATA DO SISTEMA, nao contra a data local da maquina.
  // A comparacao e por dia: a certidao continua valida durante todo o seu ultimo dia de vigencia.
  ehImpeditivo(consulta: ConsultaCadin): boolean {
    if (consulta.impeditivo) {
      return true;
    }
    if (!consulta.dataValidade) {
      return true;
    }
    if (!this.dataSistema) {
      // enquanto a data do sistema nao chega, vale o que o servidor ja calculou
      return consulta.impeditivo;
    }
    return moment(consulta.dataValidade).isBefore(moment(this.dataSistema), 'day');
  }


  getStatusCadin(consulta: ConsultaCadin):{cssClass: string; tooltip:string}{
    if(!consulta.certidaoDisponivel){
      return{
        cssClass: 'cadin-cinza',
        tooltip:consulta.mensagem,
      };
    }
    if(this.ehImpeditivo(consulta)){
      return{cssClass: 'cadin-amarelo', tooltip:'Com impedimento'};
    }
    return {cssClass: 'cadin-verde', tooltip: 'Sem impedimento'}
  }
}
